import styles from './ContentGames.module.css';
import orangeFrame from '../../assets/images/Rectangle_220.png';
import handle from '../../assets/images/Union.svg';

export default function ContentGames() {
  return (
    <section className={styles.gamesSection}>
      <div className={styles.gamesCardBox}>
        <img
          src={orangeFrame}
          alt=""
          aria-hidden="true"
          className={styles.orangeFrame}
        />
        <img
          src={handle}
          alt=""
          aria-hidden="true"
          className={styles.handle}
        />
        <div className={styles.Gamescontent}>
          <h2>Games</h2>
          <strong>Diversão sob medida para todos os perfis.</strong>
          <p>
            Cartões presente, licenças e moedas digitais das plataformas mais populares, ideais para presentear e surpreender.
          </p>
          <div className={styles.gridGames}>
            <img src={require('../../assets/images/1.png')} alt="Genshin Impact" />
            <img src={require('../../assets/images/2.png')} alt="Zelda" />
            <img src={require('../../assets/images/3.png')} alt="Rivals" />
            <img src={require('../../assets/images/4.png')} alt="Pokemon Scarlet" />
            <img src={require('../../assets/images/5.png')} alt="PUBG" />
            <img src={require('../../assets/images/6.png')} alt="Super Smash Bros" />
            <img src={require('../../assets/images/7.png')} alt="Playstation" />
            <img src={require('../../assets/images/8.png')} alt="Nintendo eShop" />
            <img src={require('../../assets/images/9.png')} alt="Xbox Gift Card" />
          </div>
        </div>
      </div>
      {/* Bloco fora do card, centralizado abaixo */}
      <div className={styles.ctaWrapper}>
        <p className={styles.ctaText}>
          Transformamos recompensas em experiências e processos em jornadas simples e marcantes.
          Fale com a gente e descubra como entregar valor de um jeito leve, rápido e memorável.
        </p>
        <a href="https://tally.so/r/3qXVr9" className={styles.ctaButton} target="_blank" rel="noopener noreferrer">
          Solicite uma proposta personalizada {/*<span aria-hidden="true">→</span>*/}
        </a>
      </div>
    </section>
  );
}
